import React, { useLayoutEffect } from "react";
import { useTranslation } from "react-i18next";
import BannerSection from "../BannerSection/BannerSection";

const QuienesSomos = () => {

    useLayoutEffect(() => {
            window.scrollTo(0, 0)
        });

        const { t } = useTranslation();

    return (
        <section className="quienes-somos">
            <BannerSection />
            
            <div className="container-intro">
                <img src="../../assets/img/logo.webp" alt="YASKIA" title="YASKIA" />
                <article>
                    {t("quienessomos.intro1")}
                    <br/><br/>
                    {t("quienessomos.intro2")}
                    <br/><br/>
                    {t("quienessomos.intro3")}
                </article>
            </div>

            <div className="container-mision">
                <div className="img-mision" style ={ {backgroundImage: `url('../assets/img/img-mision.webp')` } }></div>
                <div className="txt-mision">
                    <h2>
                        {t("quienessomos.mision")}
                    </h2>
                    <article>
                        {t("quienessomos.misiontxt")}
                    </article>
                </div>
            </div>

            <div className="container-titular">
                <h2>
                    {t("quienessomos.compromiso")}
                </h2>
                <article>
                    {t("quienessomos.compromisotxt")}
                </article>
            </div>

            <div className="container-items">
                <div className="item-card">
                    <img src="../../assets/img/qs-calidad.webp" alt={t("quienessomos.calidad")} title={t("quienessomos.calidad")}/>
                    <h3>
                        {t("quienessomos.calidad")}
                    </h3>
                    <article>
                        {t("quienessomos.calidadtxt")}
                    </article>
                </div>
                <div className="item-card">
                    <img src="../../assets/img/qs-profesionalismo.webp" alt={t("quienessomos.profesionalismo")} title={t("quienessomos.profesionalismo")}/>
                    <h3>
                        {t("quienessomos.profesionalismo")}
                    </h3>
                    <article>
                        {t("quienessomos.profesionalismotxt")}
                    </article>
                </div>
                <div className="item-card">
                    <img src="../../assets/img/qs-transparencia.webp" alt={t("quienessomos.transparencia")} title={t("quienessomos.transparencia")}/>
                    <h3>
                        {t("quienessomos.transparencia")}
                    </h3>
                    <article>
                        {t("quienessomos.transparenciatxt")}
                    </article>
                </div>
            </div>

            <div className="container-titular">
                <h2>
                    {t("quienessomos.proyeccion")}
                </h2>
                <article>
                    {t("quienessomos.proyecciontxt")}
                </article>
            </div>

            <div className="container-compromiso">
                <div className="txt">
                    <img src="../../assets/img/logo.webp" alt="YASKIA" title="YASKIA" />
                    <h2>
                        {t("quienessomos.compromiso2")}
                    </h2>
                    <article>
                        {t("quienessomos.compromiso2txt")}
                    </article>
                </div>
                <div className="img" style ={ {backgroundImage: `url('../assets/img/qs-langostinos.webp')` } }></div>
            </div>

        </section>
    );
}

export default QuienesSomos;
